// These helpers are calling FTW's own server-side routes
// so, they are not directly calling Marketplace API or Integration API.
// You can find these api endpoints from 'server/api/...' directory
//
// This file provides backward compatibility for existing code.
// New code should import directly from '../api/index.js' or specific API client files.

// Import HTTP utilities directly
import {
  apiBaseUrl,
  typeHandlers,
  serialize,
  deserialize,
  post,
  postJson,
  get,
  put,
  putJson,
  del,
} from '../api/httpClient';

// Import API clients directly
import { usersAPI } from '../api/clients/usersAPI';
import { listingsAPI } from '../api/clients/listingsAPI';
import { transactionsAPI } from '../api/clients/transactionsAPI';
import { reviewsAPI } from '../api/clients/reviewsAPI';
import { commentsAPI } from '../api/clients/commentsAPI';
import { availabilityExceptionsAPI } from '../api/clients/availabilityExceptionsAPI';
import { subscriptionsAPI } from '../api/clients/subscriptionsAPI';
import { googleStorageAPI } from '../api/clients/googleStorageAPI';
import { organizationProfilesAPI } from '../api/clients/organizationProfilesAPI';
import { orgTeamAPI } from '../api/clients/orgTeamAPI';
import { creditsAPI } from '../api/clients/creditsAPI';
import { wherebyAPI } from '../api/clients/wherebyAPI';
import { emailAPI } from '../api/clients/emailAPI';
import { communityAPI } from '../api/clients/communityAPI';
import { intercomAPI } from '../api/clients/intercomAPI';
import { stripeServerAPI } from '../api/clients/stripeServerAPI';
import { linkPreviewAPI } from '../api/clients/linkPreviewAPI';
import { authAPI } from '../api/clients/authAPI';
import { coreAPI } from '../api/clients/coreAPI';
import { sendbirdAPI } from '../api/clients/sendbirdAPI';
import { audienceAPI } from '../api/clients/audienceAPI';
import { airtableAPI } from '../api/clients/airtableAPI';
import { brevoAPI } from '../api/clients/brevoAPI';
import { consentAPI } from '../api/clients/consentAPI';

// Export HTTP utilities
export { apiBaseUrl, typeHandlers, serialize, deserialize, post, postJson, get, put, putJson, del };

// Export domain-based API clients
export {
  usersAPI,
  listingsAPI,
  transactionsAPI,
  reviewsAPI,
  commentsAPI,
  availabilityExceptionsAPI,
  subscriptionsAPI,
  googleStorageAPI,
  organizationProfilesAPI,
  orgTeamAPI,
  creditsAPI,
  wherebyAPI,
  emailAPI,
  communityAPI,
  intercomAPI,
  stripeServerAPI,
  linkPreviewAPI,
  authAPI,
  coreAPI,
  sendbirdAPI,
  audienceAPI,
  airtableAPI,
  brevoAPI,
  consentAPI,
};

// Direct function exports for backward compatibility
// These provide direct access to specific API functions without requiring the API object
export const transactionLineItems = coreAPI.transactionLineItems;
export const initiatePrivileged = coreAPI.initiatePrivileged;
export const transitionPrivileged = coreAPI.transitionPrivileged;
export const createUserWithIdp = authAPI.createUserWithIdp;
